import React, { useEffect, useState } from 'react'
import styled from 'styled-components';

import vw from 'src/styles/utils';

import mockData from 'src/data/instagram';

// const PROXY = 'https://bam-cors-anywhere.herokuapp.com/';
// const BASE_URL = 'https://www.instagram.com/the.amazing.brentwood/?__a=1';
// const HEADERS = {
// 	'Content-Type': 'application/json',
// 	'Access-Control-Allow-Origin': '*',
// 	'Access-Control-Allow-Methods': '*',
// 	accept: 'application/json',
// };

function Instagram() {
  const [postsData, setPostsData] = useState(null);

  useEffect(() => {
    fetchIGData();
  }, [])

  const fetchIGData = async () => {
    // const response = await fetch(PROXY+BASE_URL, {
    // 	headers: HEADERS
    // });
    // const data = await response.json();
    let data = [];

    for (let i = 0; i < 9; i++) {
      data.push(
        {
          url: "https://www.instagram.com/p/" + mockData.graphql.user.edge_owner_to_timeline_media.edges[i].node.shortcode + "/",
          image: mockData.graphql.user.edge_owner_to_timeline_media.edges[i].node.thumbnail_resources[2].src
        }
      )
    }
    setPostsData(data);
  }

  return (
    <Root>
      {
        postsData?.map(post => (
          <Post href={post.url} target="_blank" rel="noopener noreferrer">
            <img src={post.image} alt="ig" />
          </Post>
        ))
      }
    </Root>
  )
}

const Root = styled.section`
	display: grid;
	grid-template-columns: repeat(9, 1fr);
	${vw('height', 160)}
`;

const Post = styled.a`
	img {
		width: 100%;
		height: auto;
	}
`;

export default Instagram

